import React, {useCallback, useState} from 'react';
import {debounce, isEmpty} from 'lodash';
import {SelectBase} from '../FormBases';
import {alertByError} from 'utils/alerts';
import {getBmGlobalFieldMappingTarget} from 'api/import-management';

const defaultProps = {
  name: 'field_value',
  placeholder: 'Select / Search Data',
  cacheOptions: true,
  defaultOptions: false,
  filters: {},
  onChange: () => {},
  getOptionLabel: (option) => option.mapping_target,
  getOptionValue: (option) => option.mapping_target,
};

function SelectTargetFieldName(props) {
  const {filters, onChange, targetField, changeLoading, ...rest} = props;

  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function loadOptions(inputValue) {
    setIsLoading(true);
    try {
      const {data} = await getBmGlobalFieldMappingTarget({
        ...filters,
        search: inputValue,
      });

      setOptions(data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      await alertByError(error);
    }
  }

  async function handleChange(selected) {
    if (onChange) onChange(selected);
  }

  const handleDebounceChange = useCallback(debounce(loadOptions, 500));

  return (
    <SelectBase
      arrowRenderer={null}
      styles={{menuPortal: (base) => ({...base, zIndex: 5})}}
      className="w-10 react-select-container"
      defaultValue={targetField ? {mapping_target: targetField} : null}
      onMenuOpen={() => {
        if (isEmpty(options)) {
          loadOptions();
        }
      }}
      isLoading={isLoading || changeLoading}
      options={options}
      onInputChange={(e, actionMeta) => {
        const {action} = actionMeta;
        if (action === 'input-change') handleDebounceChange(e);
      }}
      onBlur={() => setOptions([])}
      onChange={handleChange}
      {...rest}
    />
  );
}

SelectTargetFieldName.defaultProps = defaultProps;

export default SelectTargetFieldName;
